import { useMemo } from "react";
import { Ghost, Snowflake, Sparkles, Star, Heart, Leaf, Sun, Beer } from "lucide-react";
import { useFestival } from "../context/FestivalContext";

const ICONS = {
  ghost: Ghost,
  snow: Snowflake,
  sparkles: Sparkles,
  star: Star,
  heart: Heart,
  clover: Leaf,
  leaf: Leaf,
  sun: Sun,
  beer: Beer,
};

// Overlay decorativo a tema (site-wide): icone che scendono dolcemente.
export const FestivalDecorations = () => {
  const { festival } = useFestival();

  const particles = useMemo(() => {
    if (!festival) return [];
    return Array.from({ length: 16 }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 8,
      duration: 9 + Math.random() * 8,
      size: 14 + Math.random() * 18,
      drift: (Math.random() * 40 - 20).toFixed(0),
      opacity: 0.12 + Math.random() * 0.18,
    }));
  }, [festival]);

  if (!festival) return null;
  const Icon = ICONS[festival.motif] || Sparkles;

  return (
    <div className="fixed inset-0 z-[30] pointer-events-none overflow-hidden" data-testid="festival-decorations" aria-hidden="true">
      <style>{`
        @keyframes festFall {
          0% { transform: translateY(-8vh) translateX(0) rotate(0deg); }
          100% { transform: translateY(110vh) translateX(var(--drift, 0px)) rotate(180deg); }
        }
      `}</style>
      {particles.map((p) => (
        <span
          key={p.id}
          style={{
            position: "absolute",
            top: 0,
            left: `${p.left}%`,
            color: festival.accent || "#D47738",
            opacity: p.opacity,
            animation: `festFall ${p.duration}s linear ${p.delay}s infinite`,
            "--drift": `${p.drift}px`,
          }}
        >
          <Icon style={{ width: p.size, height: p.size }} strokeWidth={1.5} />
        </span>
      ))}
    </div>
  );
};
